import { render, staticRenderFns } from "./CreateJournal.vue?vue&type=template&id=ef814058&"
import script from "./CreateJournal.vue?vue&type=script&lang=ts&"
export * from "./CreateJournal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef814058')) {
      api.createRecord('ef814058', component.options)
    } else {
      api.reload('ef814058', component.options)
    }
    module.hot.accept("./CreateJournal.vue?vue&type=template&id=ef814058&", function () {
      api.rerender('ef814058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general-journal/CreateJournal.vue"
export default component.exports